class PredictiveSearch {
  constructor() {
    this.container = document.getElementById('Search-Header');

    if (!this.container) {
      console.log('Barre de recherche header non trouvée');
      return;
    }

    this.form = this.container.querySelector('form');
    this.input = this.container.querySelector('#header-search-input');
    this.resultsContainer = this.container.querySelector('.header-search-results');
    this.predictiveSearchDiv = this.resultsContainer?.querySelector('.thb-predictive-search');

    this.hasStartedSearch = false;
    this.hasSubmittedSearch = false;
    this.lastQuery = '';
    this.lastResultsCount = 0;

    if (!this.form || !this.input) return;

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener(
      'input',
      debounce(() => {
        this.onChange();
      }, 300)
    );

    this.input.addEventListener('focus', () => {
      if (this.getQuery().length > 0) {
        this.resultsContainer?.classList.add('active');
      }
    });

    document.addEventListener('click', (event) => {
      if (!this.container.contains(event.target)) {
        this.close(false);
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.close(false);
      }
    });
  }

  track(eventName, properties = {}) {
    if (window.posthog) {
      window.posthog.capture(eventName, properties);
    }
  }

  getQuery() {
    return this.input.value.trim();
  }

  normalizeQuery(query) {
    return query
      .toLowerCase()
      .trim()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.close(false);
      return;
    }

    this.lastQuery = searchTerm;
    this.resultsContainer?.classList.add('active');

    if (!this.hasStartedSearch) {
      this.hasStartedSearch = true;
      this.track('search_started', {
        query: searchTerm,
        query_normalized: this.normalizeQuery(searchTerm),
        length: searchTerm.length
      });
    }

    this.getSearchResults(searchTerm);
  }

  onFormSubmit(event) {
    const query = this.getQuery();

    if (!query.length) {
      event.preventDefault();
      return;
    }

    this.hasSubmittedSearch = true;
  }

  getSearchResults(searchTerm) {
    if (!this.resultsContainer || !this.predictiveSearchDiv) return;

    this.resultsContainer.classList.add('loading');

    fetch(
      `${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&resources[type]=product,article,query&resources[limit]=10&section_id=predictive-search`
    )
      .then((response) => {
        this.resultsContainer.classList.remove('loading');
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const section = doc.querySelector('#shopify-section-predictive-search');

        const resultsMarkup = section ? section.innerHTML : '';
        const resultsCount =
          section?.querySelectorAll('product-card-small').length ||
          section?.querySelectorAll('a[href*="/products/"]').length ||
          0;

        this.lastResultsCount = resultsCount;

        this.track('search_results_loaded', {
          query: searchTerm,
          query_normalized: this.normalizeQuery(searchTerm),
          results_count: resultsCount
        });

        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        console.error('Erreur:', error);
        this.resultsContainer.classList.remove('loading');
      });
  }

  renderSearchResults(resultsMarkup) {
    if (!this.predictiveSearchDiv) return;

    this.predictiveSearchDiv.innerHTML = resultsMarkup;
  }

  maybeTrackAbandoned() {
    if (this.hasStartedSearch && !this.hasSubmittedSearch && this.lastQuery.length > 0) {
      this.track('search_abandoned', {
        query: this.lastQuery,
        query_normalized: this.normalizeQuery(this.lastQuery),
        results_count: this.lastResultsCount
      });
    }
  }

  close(shouldTrackAbandon = true) {
    if (shouldTrackAbandon) {
      this.maybeTrackAbandoned();
    }

    this.resultsContainer?.classList.remove('active');
    this.resetSearchState();
  }

  resetSearchState() {
    this.hasStartedSearch = false;
    this.hasSubmittedSearch = false;
    this.lastQuery = '';
    this.lastResultsCount = 0;
  }
}

window.addEventListener('load', () => {
  if (typeof PredictiveSearch !== 'undefined') {
    new PredictiveSearch();
  }
});